import { styled } from '@mui/material';

import { MIN_WIDTH_MD } from '../../theme/breakpoints';

const StyledPageContent = styled('div')`
  flex: 1 0 auto;
  margin-bottom: 2rem;

  @media (min-width: ${MIN_WIDTH_MD}) {
    margin-bottom: 4rem;
  }
`;

export default StyledPageContent;
